import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'

import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ForumIcon from '@material-ui/icons/Forum'
import { sendMessage } from '../../utils/iframeUtil'

const StyledAnalyzedTopic = styled(ListItem)`
  width: '100%';
  border-radius: 3px;
  border: 1px solid gray;
  color: white;
  margin: 10px;
  padding: 10px;
`

const AnalyzedTopic = ({ analysis }) => {
  const onLinkClick = (type, data) => () => sendMessage({ type, data })

  return (
    <StyledAnalyzedTopic button onClick={onLinkClick('gotoAnalysis', analysis)}>
      <ListItemIcon>
        <ForumIcon />
      </ListItemIcon>
      <ListItemText primary={analysis.selectedTopic.name} />
    </StyledAnalyzedTopic>
  )
}

AnalyzedTopic.defaultProps = {
  analysis: {
    selectedTopic: { name: '' }
  }
}

AnalyzedTopic.propTypes = {
  analysis: PropTypes.shape({
    selectedTopic: PropTypes.shape({
      name: PropTypes.string
    })
  })
}

export default AnalyzedTopic
